<template>
  <ImageGallery
      api-endpoint="/api/sfx"
      title="Special Effects Gallery"
      subtitle="Creative special effects makeup."
  />
</template>

<script>
import ImageGallery from './ImageGallery.vue';

export default {
  name: 'SFXGallery',
  components: {
    ImageGallery
  }
};
</script>